import React from 'react';
import { useHistory } from 'react-router-dom';

import useIsDesktop from 'hooks/useIsDesktop';

import DesktopHeader from './DesktopHeader';
import DesktopMenu from './DesktopMenu';
import { MenuContentContainer, Content } from './styles';

interface Props {
  children: JSX.Element;
}

const NO_DESKTOP_ROUTES = [
  /^\/invite/,
  /^\/registration/,
  /^\/login/,
  /^\/onboarding/,
  /^\/customerSupport/,
  /^\/$/,
  /^\/invite\/token\//,
  /^\/welcome\/?$/,
  /^\/adminonboarding\/?$/,
];

const ApplicationLayout = ({ children }: Props) => {
  const history = useHistory();

  const isDesktop = useIsDesktop();
  const {
    location: { pathname },
  } = history;
  const shouldShowDesktopLayout = isDesktop && !NO_DESKTOP_ROUTES.some((route) => route.test(pathname));

  return shouldShowDesktopLayout ? (
    <>
      <DesktopHeader />
      <MenuContentContainer>
        <DesktopMenu />
        <Content>{children}</Content>
      </MenuContentContainer>
    </>
  ) : (
    children
  );
};

export default ApplicationLayout;
